(() => {
  function buildAppBanner() {
    if (!window.matchMedia || !window.matchMedia("(max-width: 991px)").matches) return;
    if (document.getElementById("point-app-banner")) return;

    const IOS_URL = "https://apps.apple.com/ua/app/%D8%A8%D9%88%D9%8A%D9%86%D8%AA-%D9%85%D9%88%D8%A8%D8%A7%D9%8A%D9%84/id1592161741";
    const ANDROID_URL = "https://play.google.com/store/apps/details?id=com.ibtechiq.pointmob&hl=ar";
    const ua = navigator.userAgent || navigator.vendor || window.opera;
    const isIOS = /iPad|iPhone|iPod/.test(ua) || (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);
    const targetUrl = isIOS ? IOS_URL : ANDROID_URL;

    const el = document.createElement("div");
    el.id = "point-app-banner";
    el.className = "point-app-banner";
    el.innerHTML = `
      <div class="point-app-banner__text">
        <div class="point-app-banner__title">اقوى العروض دائما</div>
        <div class="point-app-banner__subtitle">حمل تطبيق بوينت على موبايلك</div>
      </div>
      <a id="point-app-banner-btn" class="point-app-banner__btn" href="${targetUrl}" rel="noopener">حمل الان</a>
    `;
    document.body.insertBefore(el, document.body.firstChild);
    setTimeout(() => {
      const banner = document.getElementById("point-app-banner");
      if (banner) banner.style.display = "none";
    }, 120000);
  }

  function initCartSound() {
    let sound = null;
    let ready = false;
    const initSound = () => {
      if (ready) return;
      sound = new Audio("https://cdn.shopify.com/s/files/1/0641/0829/8282/files/success-1-6297.mp3");
      sound.volume = 0.8;
      ready = true;
    };
    const play = () => {
      try {
        if (!ready) initSound();
        sound.currentTime = 0;
        sound.play();
      } catch (_) {}
    };

    document.addEventListener("pointerdown", initSound, { once: true, passive: true });
    document.addEventListener(
      "click",
      (e) => {
        const btn = e.target && e.target.closest('button[name="add"], button[name="add-to-cart"], .product-form__submit, .add-to-cart, [data-add-to-cart]');
        if (btn) play();
      },
      { passive: true }
    );
    document.addEventListener("ajaxProduct:added", play, { passive: true });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => {
      buildAppBanner();
      initCartSound();
    });
  } else {
    buildAppBanner();
    initCartSound();
  }
})();
